import { Container, Row, Col, Carousel, Button } from 'react-bootstrap';
import '../style/AuctionCarousel.css';

// --- IMPORT DATA PUSAT (Tidak perlu import gambar lagi disini) ---
import { auctionsData } from '../data/auctionData';

const AuctionCarousel = () => {
    // Kita pakai data dari auctionsData, tidak perlu bikin array baru

    // Helper untuk format tanggal string (opsional, karena di data bentuknya Date object)
    const formatDateString = (dateObj) => {
        const options = { day: 'numeric', month: 'long', year: 'numeric' };
        return `Ending ${dateObj.toLocaleDateString('id-ID', options)}`;
    };

    return (
        <div className="auction-carousel-wrapper">
            <Container>
                <Carousel indicators={false} interval={5000}>
                    {auctionsData.map((auction) => (
                        <Carousel.Item key={auction.id}>
                            <div className="carousel-content-inner">
                                <Row className="align-items-center">
                                    <Col md={6}>
                                        {/* Panggil gambar dari data pusat */}
                                        <img
                                            className="d-block w-100 carousel-auction-image"
                                            src={auction.image}
                                            alt={auction.title}
                                        />
                                    </Col>
                                    <Col md={6} className="carousel-text-content">
                                        <h2 className="auction-title">{auction.title}</h2>
                                        {/* Pastikan field subtitle ada di auctionsData */}
                                        <h4 className="auction-subtitle">{auction.subtitle}</h4>
                                        <p className="auction-date">{formatDateString(auction.date)}</p>
                                        <p className="auction-featuring">{auction.featuring}</p>
                                        <Button
                                            variant="dark"
                                            href={auction.catalogLink}  // Mengambil link langsung dari data
                                            target="_blank"             // Membuka di tab baru (opsional tapi disarankan)
                                            rel="noreferrer"            // Keamanan standar untuk target="_blank"
                                        >
                                            View Auction Details
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </Carousel.Item>
                    ))}
                </Carousel>
            </Container>
        </div>
    );
};

export default AuctionCarousel;